module.exports = __webpack_public_path__ + "static/img/consume.d86f95f6.svg";